import { render, staticRenderFns } from "./instInputDadata.vue?vue&type=template&id=58449880&scoped=true"
import script from "./instInputDadata.vue?vue&type=script&lang=js"
export * from "./instInputDadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58449880",
  null
  
)

export default component.exports